import { NuxtAppOptions } from '@nuxt/types'
import { normalizeSitePath } from '~/assets/functions/site-url'

// Маршруты витрины строгие (router.trailingSlash), поэтому переход по ссылке
// без слеша из данных Битрикса вёл бы на 404. Дописываем слеш при переходе.
export default function ({ app }: NuxtAppOptions) {
  app.router.beforeEach((to, _from, next) => {
    const path = normalizeSitePath(to.path)
    if (path !== to.path) {
      return next({ path, query: to.query, hash: to.hash, replace: true })
    }
    next()
  })
}
